import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';
import Turnstile from './Turnstile';
import './SiteAccessGate.css';

export default function SiteAccessGate({ children }) {
  const [state, setState] = useState('checking');
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const [challengeStatus, setChallengeStatus] = useState('loading');
  useEffect(() => {
    let active = true;
    axios.get(`${API_URL}/api/turnstile/status`, { withCredentials: true }).then(({ data }) => {
      if (active) setState(data.verified ? 'verified' : 'challenge');
    }).catch(() => { if (active) { setState('unavailable'); setError('We couldn’t connect just now. Please try again.'); } });
    return () => { active = false; };
  }, [attempt]);
  const verify = async token => {
    if (!token) return;
    setState('verifying'); setError('');
    try {
      const { data } = await axios.post(`${API_URL}/api/turnstile/verify`, { 'cf-turnstile-response': token }, { withCredentials: true });
      if (!data.verified) throw new Error('Verification failed');
      setState('verified');
    } catch {
      setState('unavailable'); setError('That didn’t quite go through. You can keep browsing and try again.');
    }
  };
  const visible = state === 'unavailable' || challengeStatus === 'interactive' || challengeStatus === 'error';
  return <>
    {children}
    {state !== 'verified' && <aside className={`site-access-panel${visible ? ' is-visible' : ''}`} aria-label="Quick verification">
      {visible && <div role="status" aria-live="polite" aria-atomic="true">
        <p>{state === 'unavailable' || challengeStatus === 'error' ? 'Let’s give that another try' : 'One quick check while you browse'}</p>
        {challengeStatus === 'interactive' && <p className="site-access-hint">Tap the checkbox below to finish. Your feed is ready to browse.</p>}
      </div>}
      {(state === 'challenge' || state === 'verifying') && <Turnstile onToken={verify} onStatus={setChallengeStatus} />}
      {error && <><p role="alert">{error}</p><button type="button" onClick={() => { setError(''); setChallengeStatus('loading'); setState('checking'); setAttempt(value => value + 1); }}>Try again</button></>}
    </aside>}
  </>;
}
